"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemLabelsByRawPoints = void 0;
exports.getItemLabels = getItemLabels;
exports.getItemPartsLabels = getItemPartsLabels;
var models_1 = require("../models");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var intersectionWith_1 = __importDefault(require("lodash/intersectionWith"));
var single_select_question_helper_1 = require("./single-select-question.helper");
var constants_1 = require("../constants");
function getItemLabels(items) {
    var labels = [];
    var coreIndex = 0;
    var branchIndex = 0;
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (!item.isBranch) {
            coreIndex++;
            branchIndex = 0;
            labels.push("".concat(coreIndex));
        }
        else {
            branchIndex++;
            var letter = String.fromCharCode(96 + branchIndex);
            labels.push("".concat(coreIndex, ".").concat(letter));
        }
    }
    return labels;
}
function getItemPartsLabels(itemPerformances, itemsFromAssessment) {
    var labels = [];
    itemsFromAssessment.forEach(function (itemFromAssessment, itemIndex) {
        var itemQuestions = models_1.AssessmentTemplate.findQuestions([itemFromAssessment]);
        if (!(0, isEmpty_1.default)(itemQuestions)) {
            var questionsByItem_1 = (0, intersectionWith_1.default)(itemPerformances, itemFromAssessment.questions, function (performance, question) {
                return performance.itemExternalId === question.externalId;
            });
            if (itemFromAssessment.questions.length === 1) {
                labels.push("Q".concat(itemIndex + 1));
            }
            else {
                itemFromAssessment.questions.forEach(function (question, partIndex) {
                    var questionPart = questionsByItem_1.find(function (part) { return part.itemExternalId === question.externalId; });
                    if (questionPart) {
                        labels.push("Q".concat(itemIndex + 1).concat((0, single_select_question_helper_1.formatAnswerToLetter)(partIndex).toUpperCase()));
                    }
                });
            }
        }
    });
    return labels;
}
var getItemLabelsByRawPoints = function (scoreRawItemArr) {
    var labels = [];
    var coreIndex = 0;
    var branchIndex = 0;
    for (var _i = 0, scoreRawItemArr_1 = scoreRawItemArr; _i < scoreRawItemArr_1.length; _i++) {
        var item = scoreRawItemArr_1[_i];
        if (item.itemType === constants_1.ItemType.Core) {
            coreIndex++;
            branchIndex = 0;
            labels.push("".concat(coreIndex));
        }
        else {
            branchIndex++;
            var letter = String.fromCharCode(96 + branchIndex);
            labels.push("".concat(coreIndex, ".").concat(letter));
        }
    }
    return labels;
};
exports.getItemLabelsByRawPoints = getItemLabelsByRawPoints;
